import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import db from "../../../../api/mongodb";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
// import { defaultOptions1 } from "../../../../config/loading-config.js";
// import Lottie from "react-lottie";
import "./SafeAPsGridView.scss";
import DummyProfilePic from "../../../../images/dummy-profile-picture.svg";
import EmptyProfilePic from "../../../../images/empty-profile-image.png";

const SafeAPsGridList = ({ safeAPs, activeView, selectedTab }) => {
  console.log(safeAPs);

  if (!safeAPs.length) {
    return (
      <Col xl={4} lg={6} md={6} sm={12}>
        {console.log("test")}
        <div className="safeAPs-card">
          <img src={EmptyProfilePic} alt=""></img>
          <h2 className="safeAPs-title">No {selectedTab} users</h2>
          {/* <p className="safeAPs-location">
            <strong>No blocked users</strong>
          </p> */}
          {/* <p className="safeAPs-date">
            Registered <strong>02-07-2021</strong>
          </p> */}
        </div>
      </Col>
    );
  }

  const renderedList = safeAPs.map((safeAP) => {
    var convertedDate = safeAP.createdAt.toString().substring(0, 10);
    var safeAPItem = null;
    // console.log(safeAP)
    safeAPItem = (
      
        <Col xl={4} lg={6} md={6} sm={12} key={safeAP._id}>
          <div className="safeAPs-card">
            <img
              src={
                safeAP.formData.img && safeAP.formData.img.length
                  ? safeAP.formData.img[0].content
                  : DummyProfilePic
              }
              alt=""
            ></img>
            <h2 className="safeAPs-title">
              {safeAP.formData.firstName} {safeAP.formData.lastName}
            </h2>
            <p className="safeAPs-location">
              Location: <strong>{safeAP.formData.city}, {safeAP.formData.stateProvince}</strong>
            </p>
            <p className="safeAPs-date">
              Registered <strong>02-07-2021</strong>
            </p>
            <Link to={`/safeAPs/profile/${safeAP._id}`}>
              <Button className="btn-primary">View Profile</Button>
            </Link>
          </div>
        </Col>
      
    );

    return safeAPItem;
  });

  return <>{renderedList}</>;
};

export default SafeAPsGridList;
